export default "__VITE_ASSET__BZWCG8CF__"